import React from 'react';
import { oneOfType, array, object } from 'prop-types';
import { get, map, size, head } from 'lodash';
import Barcode from 'react-barcode';
import { OrderPdfWrapper } from '../../src/components/pdf-commons';
import { Row, Text, Column, FlexContainer, Divider } from '../../src/components/common';
import JumboLogo from '../../assets/images/jumbo_logo.png';

const InvoicingOrders = ({ match }) => {
    const data = JSON.parse(get(match, 'params.data', null));

    const titleResolver = () => {
        if (size(data) > 1) return <Text text='Código POS de pedidos' size={20} strong />;
        return (
            <>
                <Text text='Código POS del pedido&nbsp;' size={20} strong />
                <Text text={`Nº ${get(head(data), 'id')}`} size={20} strong />
            </>
        );
    };

    return (
        <OrderPdfWrapper skipQuery>
            {() => {
                return (
                    <FlexContainer direction='column'>
                        <Row mB={20}>
                            <Column direction='row' flex={3}>
                                { titleResolver() }
                            </Column>
                            <Column align='flex-end' justify='center'>
                                <img src={JumboLogo} height='19' width='100' />
                            </Column>
                        </Row>
                        <Divider />
                        <FlexContainer wrap justify='center'>
                            { map(data, (item, key) => (
                                <FlexContainer
                                    key={key}
                                    align='center'
                                    direction='column'
                                    padding={40}
                                >
                                    <Row>
                                        <Text text='PEDIDO' />
                                    </Row>
                                    <Row>
                                        <Text strong text={get(item, 'id', '0')} size={14} />
                                    </Row>
                                    <Barcode
                                        value={get(item, 'code', '0')}
                                        width={2}
                                        height={105}
                                        fontSize={30}
                                        marginTop={10}
                                        marginBottom={20}
                                    />
                                </FlexContainer>
                            ))}
                        </FlexContainer>
                    </FlexContainer>
                );
            }}
        </OrderPdfWrapper>
    );
};

InvoicingOrders.propTypes = {
    match: oneOfType([array, object])
};

InvoicingOrders.defaultProps = {
    match: {}
};

export default InvoicingOrders;
